import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformUpdates = () => {
  const updates = [
    {
      id: 1,
      type: 'feature',
      title: 'New Python Selenium Course',
      description: 'Master web automation with our comprehensive Python track featuring 25+ hands-on missions.',
      icon: 'Code',
      color: 'var(--color-primary)',
      date: '2025-01-02'
    },
    {
      id: 2,
      type: 'achievement',
      title: '10,000+ Developers Learning',
      description: 'Join our growing community of automation engineers mastering Selenium skills.',
      icon: 'Users',
      color: 'var(--color-success)',
      date: '2025-01-01'
    },
    {
      id: 3,
      type: 'mission',
      title: 'Boss Mission: E-commerce Testing',
      description: 'Challenge yourself with our advanced e-commerce automation testing scenario.',
      icon: 'Target',
      color: 'var(--color-secondary)',
      date: '2024-12-28'
    }
  ];

  const stats = [
    {
      label: 'Active Learners',
      value: '12,847',
      icon: 'TrendingUp',
      change: '+15%'
    },
    {
      label: 'Missions Completed',
      value: '89,234',
      icon: 'CheckCircle',
      change: '+23%'
    },
    {
      label: 'Success Rate',
      value: '94.2%',
      icon: 'Award',
      change: '+2.1%'
    }
  ];

  return (
    <div className="w-full max-w-md mx-auto space-y-6">
      {/* Platform Statistics */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="BarChart3" size={20} className="mr-2" color="var(--color-primary)" />
          Platform Statistics
        </h3>
        <div className="space-y-4">
          {stats?.map((stat, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={stat?.icon} size={16} color="var(--color-primary)" />
                </div>
                <span className="text-sm text-muted-foreground">{stat?.label}</span>
              </div>
              <div className="text-right">
                <div className="text-lg font-semibold text-foreground">{stat?.value}</div>
                <div className="text-xs text-success">{stat?.change}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Recent Updates */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Zap" size={20} className="mr-2" color="var(--color-accent)" />
          What's New
        </h3>
        <div className="space-y-4">
          {updates?.map((update) => (
            <div key={update?.id} className="flex space-x-3">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center"
                     style={{ backgroundColor: `${update?.color}20` }}>
                  <Icon name={update?.icon} size={18} color={update?.color} />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground mb-1">
                  {update?.title}
                </h4>
                <p className="text-xs text-muted-foreground mb-2">
                  {update?.description}
                </p>
                <div className="text-xs text-muted-foreground">
                  {new Date(update.date)?.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Security Badge */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-4">
        <div className="flex items-center justify-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} color="var(--color-success)" />
            <span className="text-xs text-muted-foreground">SSL Protected</span>
          </div>
          <div className="w-px h-4 bg-border"></div>
          <div className="flex items-center space-x-2">
            <Icon name="Lock" size={16} color="var(--color-success)" />
            <span className="text-xs text-muted-foreground">256-bit Encryption</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformUpdates;